import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import Spinner from "@/components/Spinner";
import Title from "@/components/Title";
import { useDataTableQuery } from "@/components/data-table/hooks/useDataTableQuery";
import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import { List } from "@/components/list/List";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { isRequired } from "@/lib/form";
import { isNotId } from "@/lib/utils/isNotId";
import { displayStoreGroup } from "@/schemas/storeGroup";
import { ReadStoreGroup, WriteStoreGroup } from "@/types/storeGroup";
import { useTranslation } from "react-i18next";

const StoreGroupStores = () => {
  const { t } = useTranslation();
  const { query } = useDataTableQuery();
  const { config, mutation } = useDictionaryContext<
    ReadStoreGroup,
    WriteStoreGroup
  >();
  const { ns } = config;
  const isPending = mutation.isPending || query.isFetching;

  return (
    <>
      <Fieldset className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(displayStoreGroup.unwrap().shape)
          .filter(([key]) => isNotId(key))
          .map(([key, field], index) => (
            <Field
              key={index}
              name={key}
              label={t(`${ns}.fields.${key}`)}
              required={isRequired(field)}
              render={({ field }) => (
                <Input disabled={isPending} className="w-full" {...field} />
              )}
            />
          ))}
      </Fieldset>
      <Separator className="my-4" />
      <Title level={4} className="mb-4">
        {t("storeGroups.storeGroupStores.title")}
      </Title>

      <div className="relative flex flex-col grow">
        {isPending && (
          <div className="absolute inset-0 bg-white/50 z-50">
            <Spinner className="absolute inset-0" />
          </div>
        )}
        <List.Menubar>
          <List.Menubar.Tools />
          <List.Menubar.Columns />
          <List.Menubar.Reset />
        </List.Menubar>
        <div className="flex flex-row grow gap-2 overflow-hidden">
          <List.Content className="overflow-x-auto flex-grow">
            <List.Status>
              <List.SelectedRowsStatus />
            </List.Status>
          </List.Content>
        </div>
      </div>
    </>
  );
};

export default StoreGroupStores;
